'use client';

import { useShallow } from 'zustand/react/shallow';

import { useCourseQuizGenerationLockStore as useCourseQuizGenerationLockStoreContext } from './provider';

/**
 * Primary hook for course quiz generation lock store.
 * Uses shallow selection to avoid unnecessary re-renders.
 */
export function useCourseQuizGenerationLock() {
  return useCourseQuizGenerationLockStoreContext(
    useShallow(state => ({
      isLocked: state.isLocked,
      generatingCardIndex: state.generatingCardIndex,
      setLocked: state.setLocked,
      startGenerating: state.startGenerating,
      stopGenerating: state.stopGenerating,
      reset: state.reset,
    })),
  );
}

/**
 * Backwards-compatible selector hook.
 */
export const useCourseQuizGenerationLockStore = useCourseQuizGenerationLockStoreContext;

export function useIsCourseQuizGenerationLocked(): boolean {
  return useCourseQuizGenerationLockStoreContext(state => state.isLocked);
}

export function useGeneratingCourseCardIndex(): number | null {
  return useCourseQuizGenerationLockStoreContext(state => state.generatingCardIndex);
}
